module.exports = __webpack_public_path__ + "img/custom-dropdown.c0fea7ba.png";